export const types = {
    ASSIGN: 'ASSIGN',
    DELCOLUMN: 'DELETE-COLUMN',
    DELROW: 'DELETE-ROW',
    INSERTROW: 'INSERT-ROW',
    INSERTCOLUMN: 'INSERT-COLUMN',
    JOIN: 'JOIN',
    MERGE: 'MERGE',
    DUPLICATE: 'REMOVE-DUPLICATE-ROWS',
    GETCOLUMN: 'GET-COLUMN',
    UPDATECELL: 'UPDATE-CELL',
    LENGTH: 'LENGTH'
};
